import React from 'react';
import { useIsDesktop } from '@/hooks/useMediaQuery';
import { StatisticsPageDesktop } from './StatisticsPage.Desktop';
import { StatisticsPageMobile } from './StatisticsPage.Mobile';

/** Statistics: stat cards and the paged closed positions list. */
export const StatisticsPage: React.FC = () => {
  const isDesktop = useIsDesktop();
  return isDesktop ? <StatisticsPageDesktop /> : <StatisticsPageMobile />;
};
